import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISafetyCaseStatus,
  ISafetyCaseStatusUpdateUpsert,
} from '../../interfaces'

const getUpdateSafetyCaseStatusMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/sms/SafetyCaseStatuses`,
})

const useUpdateSafetyCaseStatusMutation: IUseUpdateMutation<ISafetyCaseStatus, ISafetyCaseStatusUpdateUpsert> =
  (params, options = {}) => {
    const request = useMemo(() => getUpdateSafetyCaseStatusMutationRequest(params), [params])

    const updateSafetyCaseStatus: IUpdateFn<ISafetyCaseStatusUpdateUpsert, ISafetyCaseStatus> = useCallback(
      async data => axios({ ...request, data }).then(res => res.data),
      [request],
    )

    const response = useMutation<ISafetyCaseStatus, Error, ISafetyCaseStatusUpdateUpsert>({
      mutationFn: updateSafetyCaseStatus,
      ...options,
    })

    return response
  }

export default useUpdateSafetyCaseStatusMutation
